(function () {
  var SESSION_CACHE_KEY = 'vensoul-search-index-v6-recent-products';
  var SESSION_CACHE_TTL = 10 * 60 * 1000;

  var cache = window.VenSoulSearchIndexCache = window.VenSoulSearchIndexCache || {
    products: [],
    keys: {},
    loaded: false,
    promise: null,
    listeners: []
  };
  cache.products = cache.products || [];
  cache.keys = cache.keys || {};
  cache.listeners = cache.listeners || [];

  function loadSessionCache() {
    if (cache.loaded || cache.products.length) return;

    try {
      var raw = window.sessionStorage && window.sessionStorage.getItem(SESSION_CACHE_KEY);
      if (!raw) return;

      var stored = JSON.parse(raw);
      if (!stored || !Array.isArray(stored.products)) return;
      if (Date.now() - parseInt(stored.storedAt || '0', 10) > SESSION_CACHE_TTL) return;

      addIndexProducts(stored.products);
      cache.loaded = true;
    } catch (error) {
      return;
    }
  }

  function saveSessionCache() {
    try {
      if (!window.sessionStorage || !cache.products.length) return;
      window.sessionStorage.setItem(SESSION_CACHE_KEY, JSON.stringify({
        storedAt: Date.now(),
        products: cache.products
      }));
    } catch (error) {
      return;
    }
  }

  function escapeHtml(value) {
    return (value == null ? '' : String(value)).replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function escapeAttr(value) {
    return escapeHtml(value);
  }

  function normalizeSearch(value) {
    var normalized = (value || '').toString().toLowerCase().trim();

    if (typeof normalized.normalize === 'function') {
      normalized = normalized.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    return normalized.replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function getSearchTerms(value) {
    return normalizeSearch(value).split(/\s+/).filter(Boolean);
  }

  function buildSectionUrl(sectionId, page) {
    var url = new URL('/collections/all', window.location.origin);
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('page', String(page || 1));
    return url;
  }

  function parseSection(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  function notifyIndexProgress() {
    cache.listeners.slice().forEach(function (listener) {
      try {
        listener();
      } catch (error) {}
    });
  }

  function addProgressListener(listener) {
    cache.listeners.push(listener);

    return function () {
      cache.listeners = cache.listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function addIndexProducts(products) {
    products.forEach(function (product) {
      var key = product.id || product.url || product.title;
      if (!key || cache.keys[key]) return;

      product.normalizedSearch = normalizeSearch(product.search || '');
      product.index = parseInt(product.index || '0', 10);
      product.price = parseInt(product.price || '0', 10);
      product.publishedAt = parseInt(product.publishedAt || '0', 10);
      product.createdAt = parseInt(product.createdAt || '0', 10);
      cache.keys[key] = true;
      cache.products.push(product);
    });
  }

  function getProductRecentTime(product) {
    return parseInt(product.publishedAt || product.createdAt || '0', 10);
  }

  function getRecentlyAddedProducts(limit) {
    return cache.products
      .filter(function (product) {
        return product.available !== false;
      })
      .slice()
      .sort(function (a, b) {
        var recentDiff = getProductRecentTime(b) - getProductRecentTime(a);
        if (recentDiff !== 0) return recentDiff;
        return (a.index || 0) - (b.index || 0);
      })
      .slice(0, limit || 8);
  }

  function loadIndexPage(page) {
    return fetch(buildSectionUrl('vensoul-shop-search-index', page).toString(), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Search index request failed');
        return response.text();
      })
      .then(function (html) {
        var script = parseSection(html, '[data-vs-shop-index-json]');
        if (!script) throw new Error('Search index response missing');

        var data = JSON.parse(script.textContent || '{}');
        var pageCount = parseInt(data.pages || page, 10);

        addIndexProducts(Array.isArray(data.products) ? data.products : []);
        notifyIndexProgress();

        return {
          page: page,
          pageCount: pageCount,
          products: cache.products
        };
      });
  }

  function loadFullIndex() {
    return loadIndexPage(1).then(function (firstPage) {
      var pageCount = parseInt(firstPage.pageCount || 1, 10);
      var pageRequests = [];

      for (var page = 2; page <= pageCount; page += 1) {
        pageRequests.push(loadIndexPage(page));
      }

      if (!pageRequests.length) return cache.products;

      return Promise.all(pageRequests).then(function () {
        return cache.products;
      });
    });
  }

  function ensureSearchIndex() {
    loadSessionCache();

    if (cache.loaded) return Promise.resolve(cache.products);
    if (cache.promise) return cache.promise;

    cache.promise = loadFullIndex()
      .then(function () {
        cache.loaded = true;
        saveSessionCache();
        return cache.products;
      })
      .catch(function (error) {
        cache.promise = null;
        throw error;
      });

    return cache.promise;
  }

  cache.ensureSearchIndex = ensureSearchIndex;
  cache.getRecentlyAddedProducts = getRecentlyAddedProducts;

  function startSearchIndexLoad() {
    if (cache.loaded || cache.promise) return;
    ensureSearchIndex().catch(function () {});
  }

  function productMatchesSearch(product, terms) {
    if (!terms.length) return true;

    var productSearch = product.normalizedSearch || normalizeSearch(product.search || '');
    product.normalizedSearch = productSearch;

    return terms.every(function (term) {
      return productSearch.indexOf(term) !== -1;
    });
  }

  function getSearchResults(term) {
    var terms = getSearchTerms(term);

    return cache.products
      .filter(function (product) {
        return productMatchesSearch(product, terms);
      })
      .sort(function (a, b) {
        return (a.index || 0) - (b.index || 0);
      });
  }

  function buildShopSearchUrl(term) {
    var url = new URL('/pages/shop', window.location.origin);
    if (term) url.searchParams.set('q', term);
    return url.toString();
  }

  function buildResponsiveImage(product, position) {
    if (!product.imageUrl) {
      return '<div class="vs-shop-card__placeholder">' + escapeHtml((product.title || '?').slice(0, 1)) + '</div>';
    }

    var attrs = [
      'src="' + escapeAttr(product.imageUrl) + '"',
      'alt="' + escapeAttr(product.imageAlt || product.title || '') + '"',
      'loading="' + (position < 4 ? 'eager' : 'lazy') + '"',
      'decoding="async"',
      'sizes="(min-width: 750px) 170px, 46vw"'
    ];

    if (position < 4) attrs.push('fetchpriority="high"');
    attrs.push('srcset="' + escapeAttr(product.imageSrcset || buildImageSrcset(product.imageUrl)) + '"');

    return '<img ' + attrs.join(' ') + '>';
  }

  function buildImageSrcset(imageUrl) {
    return [360, 540, 720, 900, 1100, 1400].map(function (width) {
      return resizeShopifyImageUrl(imageUrl, width) + ' ' + width + 'w';
    }).join(', ');
  }

  function resizeShopifyImageUrl(imageUrl, width) {
    try {
      var url = new URL(imageUrl, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (error) {
      return imageUrl;
    }
  }

  function renderProductCard(product, position) {
    var imageMarkup = product.imageUrl
      ? buildResponsiveImage(product, position || 0)
      : '<div class="vs-shop-card__placeholder">' + escapeHtml((product.title || '?').slice(0, 1)) + '</div>';

    return [
      '<a class="vs-search-card" href="', escapeAttr(product.url), '" aria-label="', escapeAttr(product.title), '">',
        '<div class="vs-search-card__media">',
          imageMarkup,
        '</div>',
        '<div class="vs-search-card__body">',
          '<span class="vs-search-card__vendor">', escapeHtml(product.vendor || 'VenSoul Studio'), '</span>',
          '<strong class="vs-search-card__title">', escapeHtml(product.title || ''), '</strong>',
          '<span class="vs-search-card__price">', product.priceHtml || '', '</span>',
        '</div>',
      '</a>'
    ].join('');
  }

  function initSearchModal(root) {
    var form = root.querySelector('[data-vs-header-search-form]');
    var input = root.querySelector('[data-vs-header-search-input]');
    var clearButton = root.querySelector('[data-vs-header-search-clear]');
    var empty = root.querySelector('[data-vs-header-search-empty]');
    var status = root.querySelector('[data-vs-header-search-status]');
    var grid = root.querySelector('[data-vs-header-search-grid]');
    var footer = root.querySelector('[data-vs-header-search-footer]');
    var viewAllButton = root.querySelector('[data-vs-header-search-view-all]');
    var dialog = root.closest('dialog');
    var searchTimer = null;
    var activeTerm = '';
    var previewLimit = 8;

    if (!form || !input || !grid) return;

    function setStatus(message) {
      if (!status) return;
      status.textContent = message || '';
      status.hidden = !message;
    }

    function setEmptyState(visible) {
      if (empty) empty.hidden = !visible;
      if (footer) footer.hidden = true;
      grid.innerHTML = '';
      setStatus('');
    }

    function updateClearButton() {
      if (clearButton) clearButton.hidden = !input.value.trim();
    }

    function renderResults(term, options) {
      options = options || {};
      var normalizedTerm = normalizeSearch(term);
      var results = getSearchResults(normalizedTerm);
      var visibleResults = results.slice(0, previewLimit);

      if (empty) empty.hidden = true;
      grid.innerHTML = visibleResults.map(renderProductCard).join('');

      if (results.length > 0) {
        setStatus(options.partial ? 'Showing early matches while the full catalog loads...' : (results.length === 1 ? '1 result found' : results.length + ' results found'));
        if (footer) footer.hidden = Boolean(options.partial);
        if (viewAllButton) {
          viewAllButton.textContent = results.length > previewLimit ? 'View all ' + results.length + ' results' : 'View results in Shop';
        }
      } else {
        setStatus('No results found. Try another character, universe or artist.');
        if (footer) footer.hidden = false;
        if (viewAllButton) viewAllButton.textContent = 'Search in Shop';
      }
    }

    function queueSearch(delay) {
      var term = input.value.trim();
      activeTerm = term;
      updateClearButton();
      clearTimeout(searchTimer);

      if (!term) {
        setEmptyState(true);
        return;
      }

      if (normalizeSearch(term).length < 2) {
        if (empty) empty.hidden = true;
        grid.innerHTML = '';
        if (footer) footer.hidden = true;
        setStatus('Type at least 2 characters');
        return;
      }

      setStatus(cache.loaded ? 'Searching...' : 'Loading full catalog...');
      if (empty) empty.hidden = true;
      if (footer) footer.hidden = true;

      searchTimer = setTimeout(function () {
        var requestedTerm = activeTerm;
        var removeProgressListener = null;

        if (!cache.loaded) {
          removeProgressListener = addProgressListener(function () {
            if (cache.loaded || activeTerm !== requestedTerm) return;
            if (getSearchResults(requestedTerm).length) {
              renderResults(requestedTerm, { partial: true });
            }
          });
        }

        ensureSearchIndex()
          .then(function () {
            if (removeProgressListener) removeProgressListener();
            if (activeTerm !== requestedTerm) return;
            renderResults(requestedTerm);
          })
          .catch(function () {
            if (removeProgressListener) removeProgressListener();
            if (activeTerm !== requestedTerm) return;
            grid.innerHTML = '';
            if (footer) footer.hidden = false;
            setStatus('Could not load search results. View all results in Shop.');
          });
      }, typeof delay === 'number' ? delay : 180);
    }

    input.addEventListener('input', function () {
      queueSearch();
    });

    input.addEventListener('search', function () {
      queueSearch(0);
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      window.location.href = buildShopSearchUrl(input.value.trim());
    });

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        input.value = '';
        input.focus();
        queueSearch(0);
      });
    }

    if (dialog) {
      var focusInput = function () {
        window.setTimeout(function () {
          input.focus();
          input.select();
        }, 80);
      };

      if (dialog.open) {
        focusInput();
        startSearchIndexLoad();
      }

      new MutationObserver(function () {
        if (dialog.open) {
          focusInput();
          startSearchIndexLoad();
        }
      }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
    }

    setEmptyState(true);
  }

  function bindSearchIntentPreload() {
    var triggers = Array.prototype.slice.call(document.querySelectorAll('search-button, .search-action, button'));
    var bound = [];

    triggers.forEach(function (trigger) {
      var clickTarget = trigger.getAttribute('on:click') || '';
      var isSearchTrigger = clickTarget.indexOf('#search-modal') !== -1 || trigger.matches('search-button, .search-action') || trigger.closest('.search-action');

      if (!isSearchTrigger || bound.indexOf(trigger) !== -1) return;
      bound.push(trigger);

      ['pointerenter', 'pointerdown', 'touchstart', 'focusin'].forEach(function (eventName) {
        trigger.addEventListener(eventName, startSearchIndexLoad, { passive: true, once: true });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-vs-header-search]').forEach(initSearchModal);
    bindSearchIntentPreload();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
